import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogIcon } from '@cpd-app/core-module/models';

@Component({
  selector: 'cpd-dialog-container2',
  templateUrl: './dialog-container2.component.html',
  styleUrls: ['./dialog-container2.component.scss']
})
export class DialogContainer2Component implements OnInit {
  @Input() public isCloseIconVisible = true;
  @Input() public title: string;
  @Input() public message: string;
  @Input() public containerClass: string;
  @Input() public icon: DialogIcon;
  @Input() public size = '609px';

  constructor(private dialogRef: MatDialogRef<any>) {}

  public ngOnInit(): void {
    this.dialogRef.addPanelClass('cpd-dialog');
    this.dialogRef.updateSize(this.size);
  }
}
